import { combineReducers } from "redux";
import toast from "./toast/index";
import modalReducer from "./modal/index";
import loader from "./loader/index";
import navbarReducer from "./navbar/index";
import newModalReducer from "./newModal/index";
import subsidiaryInfoReducer from "./subsidiaryInfo";
import appSettingsReducer from "./AppSettings";

const rootReducer = combineReducers({
  // customizer,
  // auth,
  // navbar,
  toast,
  modalReducer,
  loader,
  navbarReducer,
  newModalReducer,
  subsidiaryInfoReducer,
  appSettingsReducer
});

export default rootReducer;
export type AppState = ReturnType<typeof rootReducer>;
